import React, { useState } from 'react';
import { MenuItem, FormControl, Select } from '@material-ui/core';

export default function DropDownEditor({
  items,
  column,
  row,
  onRowChange,
  onClose,
}) {
  const [open, setOpen] = useState(false);

  const handleFocus = () => {
    setOpen(true);
  };

  const handleChange = (event) => {
    onRowChange({ ...row, [column.key]: event.target.value }, true);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <FormControl>
      <Select
        value={row[column.key] || ''}
        onChange={handleChange}
        onFocus={handleFocus}
        onClose={handleClose}
        open={open}
        autoFocus
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {items.map((item) => (
          <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
